module.exports = __webpack_public_path__ + "img/Recurso 34@300x.8a3993c8.webp";